import type { FaireProductEntity } from "../../entity_types/product";

export const p_e8c5a62x8n: FaireProductEntity = {
  token: "p_e8c5a62x8n",
  type: "product",
  name: "Earth Beach Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/1d75748b412be85bc3a76e0bca517d75cbf575f2eda71540acabfe2bb320cd37.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fbbdd0bad136c4db825021131106232dcd092df278cf4e2e833ecb71c98d1db6.jpeg",
    "https://cdn.faire.com/fastly/7cf5072eabd257c314ff79d9c7a5b8360d07fdff04ac66106aab596f5310c2ad.jpeg"
  ],
  priceDollars: 20,
  description: "Geometry Micro-loop Beach Towel\n\nMake waves. \n\nThis towel’s earned its day in the sun, and for good reason. Our super compact, quick-drying and ultra-absorbent Geometry Micro-loop Beach Towel is perfect for those who love a light beach bag but hate to sacrifice performance. Available in countless prints and patterns that are sure to look oh-so-cool on the sand, you’ll be making waves with this beach buddy.\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 65” x 31” \n * Super compact, quick-drying, and absorbent \n * Made from post-consumer recycled materials = less waste in our planet and less water usage during the manufacturing process \n * Contrast border stitch \n * Hang loop \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\nBeach Responsibly\n\nFrom its compatibility to its absorbency, our Beach Towel is guaranteed to be a favorite gym buddy – but it’s also a friend to the environment. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its natural sand-repellent weave, high absorbency and quick dry time, you’ll wash your towels less often, helping to minimize yours. \n\n\n",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:57.296Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
